(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/deposit-restriction/assets/javascripts/dialogs.js') >= 0) return;  svs.modules.push('/components/accountservices/deposit-restriction/assets/javascripts/dialogs.js');

'use strict';

class DepositRestrictionDialogs {
  constructor() {
    this.numberOfDeposits = 0;
  }
  showConfirmLimitsDialog(numberOfDeposits, isPnp) {
    const brand = isPnp ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT;
    let title = "Du har valt att kunna s\xE4tta in pengar ".concat(numberOfDeposits, " ").concat(numberOfDeposits > 1 ? 'gånger' : 'gång', " till idag.");
    if (numberOfDeposits === 0) {
      title = 'Du har valt att begränsa dig från att sätta in mer pengar idag.';
    }
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: brand,
      title,
      icon: 'deposit-limits',
      area: svs.ui.dialog.area.POPUP,
      type: svs.ui.dialog.type.CONFIRM,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: ''
      }],
      actions: [{
        title: 'Okej',
        callback: () => {
          var _svs$utils$url$queryS, _svs$accountservices$;
          let returnUrl = (_svs$utils$url$queryS = svs.utils.url.queryString) === null || _svs$utils$url$queryS === void 0 ? void 0 : _svs$utils$url$queryS.returnUrl;
          const group = (_svs$accountservices$ = svs.accountservices.deposit_restriction) === null || _svs$accountservices$ === void 0 || (_svs$accountservices$ = _svs$accountservices$.data) === null || _svs$accountservices$ === void 0 ? void 0 : _svs$accountservices$.group;
          if (group && group === 'after' && returnUrl) {
            svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl));
            return false;
          }
          if (numberOfDeposits === 0) {
            svs.utils.url.navigate('/');
            return false;
          }
          returnUrl = returnUrl ? "?returnUrl=".concat(svs.utils.url.makeInternal(returnUrl)) : '';
          svs.utils.url.navigate("".concat(svs.core.urlMapping.get('transactionsHome')).concat(returnUrl));
        }
      }]
    }));
  }
  showSetDepositLimitsDialog(numberOfDeposits, isPnp) {
    const brand = isPnp ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT;
    let title = "Vill du kunna s\xE4tta in pengar ".concat(numberOfDeposits, " ").concat(numberOfDeposits > 1 ? 'gånger' : 'gång', " till idag?");
    if (numberOfDeposits === 0) {
      title = 'Vill du begränsa dig från att sätta in mer pengar idag?';
    }
    const dialog = new svs.ui.dialog.Confirm({
      branding: brand,
      title,
      icon: 'deposit-limits',
      area: svs.ui.dialog.area.POPUP,
      type: svs.ui.dialog.type.CONFIRM,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: ''
      }],
      actions: [{
        title: 'Avbryt',
        callback: () => {
          dialog.close();
          svs.accountservices.playscanLog.postToPlayscan({
            intent: 'confirmdepositslimit',
            page: 'deposits',
            payload: {
              clicked: 'cancel'
            },
            ready_only: '0',
            session_id: 'deposits'
          });
        }
      }, {
        title: 'Bekräfta',
        callback: () => {
          dialog.close();
          this.showConfirmLimitsDialog(numberOfDeposits, isPnp);
          svs.accountservices.playscanLog.postToPlayscan({
            intent: 'confirmdepositslimit',
            page: 'deposits',
            payload: {
              confirmed: numberOfDeposits
            },
            ready_only: '0',
            session_id: 'deposits'
          });
        }
      }]
    });
    svs.accountservices.playscanLog.postToPlayscan({
      intent: 'confirmdepositslimit',
      page: 'deposits',
      payload: {
        shown: 1
      },
      ready_only: '0',
      session_id: 'deposits'
    });
    svs.ui.dialog.api.add(dialog);
  }
  static showNotAllowToDepositDialog(isPnp) {
    const brand = isPnp ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT;
    const dialog = new svs.ui.dialog.Confirm({
      branding: brand,
      title: 'Du har valt att inte kunna sätta in pengar fler gånger idag',
      icon: 'deposit-limits',
      area: svs.ui.dialog.area.POPUP,
      type: svs.ui.dialog.type.CONFIRM,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: 'Du kan tidigast sätta in pengar imorgon.'
      }],
      actions: [{
        title: 'Okej',
        callback: async () => {
          dialog.close();
          svs.ui.loader.show();
          await svs.accountservices.playscanLog.postToPlayscan({
            intent: 'confirmdepositslimit',
            page: 'deposits',
            payload: {
              shown: 1
            },
            ready_only: '0',
            session_id: 'deposits'
          });
          svs.utils.url.navigate('/');
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  }
}
svs.accountservices.deposit_restriction.DepositRestrictionDialogs = new DepositRestrictionDialogs();

 })(window);